import { createSlice } from '@reduxjs/toolkit';
import FJConstant from '../../constants/FJConstant';
import { PAGE_LIMIT, COMMUNITY_SORT_TYPE } from '../../config/dataConfig/FJCommunityData';
const pageInfo = {
    initLoading: true,
    getMoreLoading: false,
    start: 1,
    limit: PAGE_LIMIT,
    total: 0,
    hasMore: true,
};
export const initialIsLoadedPage = {
    home: false,
    community: false,
    aiTools: false,
    mySpace: false,
    myCreations: false,
    sharedCreations: false,
    likedCreations: false,
};
export const FJSliceCommunity = createSlice({
    name: 'community',
    initialState: {
        isLoadedPage: { ...initialIsLoadedPage },
        navBarTab: FJConstant.HOME,
        entirePageLoading: true,
        homeList: [],
        homePageInfo: { ...pageInfo },
        communityTypes: [],
        curCommunitySortType: COMMUNITY_SORT_TYPE[0].value,
        curCommunityType: '',
        curCommunityCategory: '',
        communityList: [],
        communityPageInfo: { ...pageInfo },
        userInfo: {
            avatar: '', //头像地址
            username: '', //用户名
            likeNum: 0,
            userKey: '',
        },
        mySpaceTabType: FJConstant.MY_CREATIONS,
        myCreationsList: [],
        myCreationsPageLoading: true,
        myCreationsDetailInfo: {},
        myCreationsDetailPageInfo: { ...pageInfo },
        myCreationsDetailList: [],
        myCreationsPageScene: FJConstant.DEFAULT,
        sharedCreationsList: [],
        sharedCreationsPageInfo: { ...pageInfo },
        likedCreationsList: [],
        likedCreationsPageInfo: { ...pageInfo },
        multipleSelectedList: [],
        getMoreListLoading: false,
        guestUserInfo: {
            guestMode: false, //访客模式
            avatar: '', //头像地址
            username: '', //用户名
            likeNum: 0,
            userKey: '',
        },
        advertisingList: [],
    },

    reducers: {
        setSliceNavBarTab: (state, action) => {
            state.navBarTab = action.payload;
            state.multipleSelectedList = [];
            switch (action.payload) {
                case FJConstant.HOME:
                    state.isLoadedPage.home = true;
                    break;
                case FJConstant.COMMUNITY:
                    state.isLoadedPage.community = true;
                    break;
                case FJConstant.AI_TOOL_LIST:
                    state.isLoadedPage.aiTools = true;
                    break;
                case FJConstant.MY_SPACE:
                    state.isLoadedPage.mySpace = true;
                    state.isLoadedPage.myCreations = true;

                    break;
                default:
                    state.isLoadedPage.home = true;
                    break;
            }
        },
        setSliceCommunityTypes: (state, action) => {
            state.communityTypes = action.payload;
        },
        setSliceCommunityList: (state, action) => {
            state.communityList = action.payload;
        },
        setSliceHomeList: (state, action) => {
            state.homeList = action.payload;
        },
        setSliceCurCommunityType: (state, action) => {
            state.curCommunityType = action.payload;
        },
        setSliceCurCommunityCategory: (state, action) => {
            state.curCommunityCategory = action.payload;
        },
        setSliceCurCommunitySortType: (state, action) => {
            state.curCommunitySortType = action.payload;
        },

        setSliceUserInfo: (state, action) => {
            state.userInfo = action.payload;
        },
        setSliceIsLoadedPage: (state, action) => {
            state.isLoadedPage = action.payload;
        },
        setSliceMySpaceTabType: (state, action) => {
            state.mySpaceTabType = action.payload;
            state.multipleSelectedList = [];
            switch (action.payload) {
                case FJConstant.MY_CREATIONS:
                    state.isLoadedPage.myCreations = true;
                    break;
                case FJConstant.SHARED_CREATIONS:
                    state.isLoadedPage.sharedCreations = true;
                    break;
                case FJConstant.LIKED_CREATIONS:
                    state.isLoadedPage.likedCreations = true;
                    break;
                default:
                    state.isLoadedPage.myCreations = true;
                    break;
            }
        },
        setSliceMyCreationsList: (state, action) => {
            state.myCreationsList = action.payload;
        },
        setSliceMyCreationsDetailList: (state, action) => {
            state.myCreationsDetailList = action.payload;
        },
        setSliceMyCreationsDetailInfo: (state, action) => {
            state.myCreationsDetailInfo = action.payload;
        },
        setSliceSharedCreationsList: (state, action) => {
            state.sharedCreationsList = action.payload;
        },
        setSliceLikedCreationsList: (state, action) => {
            state.likedCreationsList = action.payload;
        },
        setSliceMultipleSelectedList: (state, action) => {
            state.multipleSelectedList = action.payload;
        },
        setSliceMyCreationsPageScene: (state, action) => {
            state.myCreationsPageScene = action.payload;
            state.multipleSelectedList = [];
            state.isLoadedPage.myCreationsDetail = FJConstant.DEFAULT !== action.payload;
        },
        setSliceHomePageInfo: (state, action) => {
            state.homePageInfo = action.payload;
        },
        setSliceCommunityPageInfo: (state, action) => {
            state.communityPageInfo = action.payload;
        },
        setSliceMyCreationsPageLoading: (state, action) => {
            state.myCreationsPageLoading = action.payload;
        },
        setSliceSharedCreationsPageInfo: (state, action) => {
            state.sharedCreationsPageInfo = action.payload;
        },
        setSliceLikedCreationsPageInfo: (state, action) => {
            state.likedCreationsPageInfo = action.payload;
        },
        setSliceMyCreationsDetailPageInfo: (state, action) => {
            state.myCreationsDetailPageInfo = action.payload;
        },

        setSliceGuestUserInfo: (state, action) => {
            state.guestUserInfo = action.payload;
        },
        setSliceAdvertisingList: (state, action) => {
            state.advertisingList = action.payload;
        },
        setSliceEntirePageLoading: (state, action) => {
            state.entirePageLoading = action.payload;
        },
    },
});

export const {
    setSliceNavBarTab,
    setSliceCommunityTypes,
    setSliceCommunityList,
    setSliceHomeList,
    setSliceCurCommunityType,
    setSliceCurCommunityCategory,
    setSliceUserInfo,
    setSliceMySpaceTabType,
    setSliceMyCreationsList,
    setSliceMyCreationsDetailList,
    setSliceMyCreationsDetailInfo,
    setSliceSharedCreationsList,
    setSliceLikedCreationsList,
    setSliceMultipleSelectedList,
    setSliceMyCreationsPageScene,
    setSliceHomePageInfo,
    setSliceCommunityPageInfo,
    setSliceMyCreationsPageLoading,
    setSliceSharedCreationsPageInfo,
    setSliceLikedCreationsPageInfo,
    setSliceMyCreationsDetailPageInfo,
    setSliceGuestUserInfo,
    setSliceAdvertisingList,
    setSliceIsLoadedPage,
    setSliceEntirePageLoading,
    setSliceCurCommunitySortType,
    setSliceCommunitySortList,
} = FJSliceCommunity.actions;

export default FJSliceCommunity.reducer;
